import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './styles/style.css';

function Footer(){

    return(
        <section className="footer-section">
        <Container className="themed-container footer-box" fluid={true}>  
            <Row>
                <Col xl={{size:10, offset:1}}>
            <h6 className="d-flex justify-content-center ">

                <footer>  Copyright  <small>&copy; 2021 • Designed and Developed by Rishant Rokaha</small> </footer> 
            </h6>
                </Col>
            </Row>
        </Container>
        </section>


    );
}


export default Footer;